import { UrlMatchResult, UrlSegment } from '@angular/router';

const RESERVED_CATALOG_SEGMENTS = new Set(['admin', 'entrar', 'imoveis', 'inicio', 'navegacao']);

export function semanticCatalogMatcher(url: UrlSegment[]): UrlMatchResult | null {
  if (url.length < 1 || url.length > 3)
    return null;

  if (RESERVED_CATALOG_SEGMENTS.has(url[0]?.path ?? ''))
    return null;

  const [propertyTypeSlug, citySlug, districtSlug] = url;
  const posParams: Record<string, UrlSegment> = {};

  if (propertyTypeSlug)
    posParams['propertyTypeSlug'] = propertyTypeSlug;

  if (citySlug)
    posParams['citySlug'] = citySlug;

  if (districtSlug)
    posParams['districtSlug'] = districtSlug;

  return { consumed: url, posParams };
}
